<template>
  <div id="app">
    <Layout />
  </div>
</template>

<script>
import Layout from "./components/layout.vue";
export default {
  name: "App",
  components: {
    Layout,
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

a {
  color: #1c1c28;
}
.menu-item {
  line-height: 1.2rem;
  padding: 0.5rem;
  font-weight: 600;
  font-size: 1rem;
  width: 100%;
  display: inline-block;
}
.menu-item.selected {
  background-color: #427df7;
  color: #fff;
}
.menu-item .item-text {
  padding: 0px 0.4rem;
}
div.v-panel {
  padding: 40px 30px 40px 30px;
  background-color: #fff;
  min-height: 700px;
  box-shadow: 0px 0px 40px rgba(151, 176, 213, 0.25);
}
.v-panel .v-panel-title {
  line-height: 1.4rem;
  font-size: 1.4rem;
}
.v-panel-title span {
  background-color: #2f7af3;
  font-size: 1.4rem;
  color: #152c5b;
  width: 6px;
  display: inline-block;
  border-radius: 2px;
  margin-right: 15px;
}

.border-r {
  border-radius: 10px !important;
}

.v-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  border-style: hidden; /* hide standard table (collapsed) border */
  box-shadow: 0 0 0 1px #ced4de; /* this draws the table border  */
}
.v-table th,
.v-table td,
.v-table .td {
  border-top: 1px solid #ced4de;
  border-bottom: 1px solid #ced4de;
  line-height: 50px;
  padding-left: 20px;
}

.v-table thead {
  background-color: #f5f5f5;
}

.v-table td,
.v-table th {
  font-size: 1rem;
  font-weight: 550;
}
/* .v-table tr.selected{background-color: #F0F4FF; } */
.v-table tr.selected {
  background-color: #000;
  color: #fff;
}
/* .correct-bkg{background-image: url(../img/correct.png);background-size: 20px; background-repeat: no-repeat; background-position: center left 6px;} */
.txt-b {
  font-weight: 600;
}
.txt-align-r {
  text-align: right;
}
.txt-align-l {
  text-align: left;
}
.hide-obj {
  display: none;
}
.field-header {
  background-color: darkgray;
}
</style>
